<template>
  <div class="application">
    <InternalHeader
        backBtn="true"
        backBtnLabel="Заявки"
        :title="data?.title"
        class="response__header"
        :fnBack="true"
        @backBtn="goBack"
    />
    <div class="application__author">Автор: {{ data?.bid_owner_employee?.full_name || 'Не указан' }}</div>
    <div class="application__row" v-if="!data.title">
      <div class="application__wrapper container">
        <VSkeleton style="width: 832px" variants="CARD_CANDIDATE" v-if="skeleton"/>
        <VSkeleton style="width: 832px" variants="CARD_CANDIDATE_RESPONSE" v-if="skeleton"/>
      </div>
    </div>
    <div class="application__row" v-if="data.title">
      <div class="application__wrapper container">
        <MainBlock :aplication="data" :actions="data?.actions" class="application__main-block"/>

        <VSkeleton variants="CARD_TASK" v-if="skeleton"/>
      </div>

      <div>
        <ActionsMenu class="application__actions-menu"
                     v-if="data.status !== 'Отменено' && data.status !== 'Выполнено'"
                     :status="data.status"
                     :createVacancy="!data.vacancy_id"
                     style="margin-bottom: 24px"
                     @getData="getData"
        />

        <div>
          <ProgressMenu class="application__actions-menu"
                        v-if="data.status !== 'Отменено'"
                        :status="data.status"
                        :id="data.vacancy_id"
                        :max="data.hiring?.plan"
                        :current="data.hiring?.fact"
          />
        </div>

      </div>


    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {useRouter, useRoute} from "vue-router";

import ActionsMenu from "@/components/Application/ActionMenu.vue";
import MainBlock from "@/components/Application/MainBlock";
import VSkeleton from "@/components/UI/VSkeleton/index.vue";
import applications from "@/api/applications";
import InternalHeader from "@/components/InternalHeader/index.vue";
import ProgressMenu from "@/components/Application/ProgressMenu.vue";
import ResponseBaseInfoBlock from "@/components/ResponseDetailCard/ResponseBaseInfoBlock/index.vue";

const route = useRoute();
const router = useRouter();

const skeleton = ref(false)

const goBack = () => {
  router.push({path: `/applications`, query: route?.query})
};

const data = ref({});

const getData = async () => {
  skeleton.value = true;
  const res = await applications.getApplicationId(route.params.id);
  data.value = res?.data || {}
  skeleton.value = false;
}

onMounted(async () => {
  await getData()
})
</script>

<style scoped lang="scss">
.application {
  padding-bottom: 30px;

  &__breadcrumbs {
    margin-top: 12px;
    display: flex;
    align-items: center;
    color: #8F9CAC;
    text-decoration: none;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;

    p {
      margin-left: 4px;
      font-size: 14px;
      font-weight: 400;
    }
  }

  &__title {
    margin-top: 8px;
  }

  &__author {
    font-size: 14px;
    font-weight: 500;
    color: $dark-blue;
    margin-top: 8px;
  }

  &__row {
    margin-top: 24px;
    display: flex;
    align-items: flex-start;
  }

  &__actions-menu {
    margin-left: 32px;
  }

  &__questionnaire-block {
    margin-top: 24px;
  }

  &__extended-questionnaire-block {
    margin-top: 24px;
  }

  &__publish {
    width: 437px;
    margin-top: 24px;
  }

  &__modal {
    &::v-deep(.modal__body) {
      width: 304px;
    }
  }

  &__header {
    &::v-deep(.v-breadcrumbs) {
      .v-breadcrumbs__item:nth-child(2) .v-breadcrumbs__arrow {
        display: none !important;
      }
    }
  }

  &__documents {
    width: 100%;
    margin-top: 24px;
    padding: 24px;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.0392156863);
  }

  &__docs-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
    display: flex;
    gap: 8px;
  }

  &__integration-btn {
    padding-top: 8px;
    padding-right: 16px;
    .v-button {
      font-weight: 500;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0;
      text-align: right;
    }
  }
  &__modal-add-integration {
    &::v-deep(.modal__body) {
      width: 477px;
      height: auto;
      border-radius: 16px;
    }
  }

  &__modal-poups {
    &::v-deep(.modal__body) {
      width: auto;
      height: auto;
      border-radius: 16px;
    }
  }
}
</style>
